export const MODULES = [
    {
        name: "Dashboard",
        key: "dashboard",
        permissions: [
            { label: "Dashboard View", value: "dashboard.view" }
        ]
    },
    {
        name: "User",
        key: "user",
        permissions: [
            { label: "User View", value: "user.view" },
            { label: "User Create", value: "user.create" },
            { label: "User Edit", value: "user.edit" },
            { label: "User Delete", value: "user.delete" }
        ]
    },
    {
        name: "Roles",
        key: "roles",
        permissions: [
            { label: "Roles View", value: "role.view" },
            { label: "Roles Create", value: "role.create" },
            { label: "Roles Edit", value: "role.edit" },
            { label: "Roles Delete", value: "role.delete" }
        ]
    },
    {
        name: "Workshop",
        key: "workshops",
        permissions: [
            { label: "Workshop View", value: "workshop.view" },
            { label: "Workshop Create", value: "workshop.create" },
            { label: "Workshop Edit", value: "workshop.edit" },
            { label: "Workshop Delete", value: "workshop.delete" }
        ]
    },
    {
        name: "Technicians",
        key: "technicians",
        permissions: [
            { label: "Technician View", value: "technician.view" },
            { label: "Technician Create", value: "technician.create" },
            { label: "Technician Edit", value: "technician.edit" },
            { label: "Technician Delete", value: "technician.delete" }
        ]
    },
    {
        name: "Bookings",
        key: "bookings",
        permissions: [
            { label: "Booking View", value: "booking.view" },
            { label: "Booking Create", value: "booking.create" },
            { label: "Booking Edit", value: "booking.edit" },
            { label: "Booking Delete", value: "booking.delete" }
        ]
    },
    {
        name: "Jobsheet",
        key: "jobsheet",
        permissions: [
            { label: "Jobsheet View", value: "job.view" },
            { label: "Jobsheet Create", value: "job.create" },
            { label: "Jobsheet Edit", value: "job.edit" },
            { label: "Jobsheet Delete", value: "job.delete" }
        ]
    },
    {
        name: "Invoice",
        key: "invoice",
        permissions: [
            { label: "Invoice View", value: "invoice.view" },
            { label: "Invoice Create", value: "invoice.create" },
            { label: "Invoice Edit", value: "invoice.edit" },
            { label: "Invoice Delete", value: "invoice.delete" }
        ]
    },
    {
        name: "Expenses",
        key: "expenses",
        permissions: [
            { label: "Expenses View", value: "expenses.view" },
            { label: "Expenses Create", value: "expenses.create" },
            { label: "Expenses Edit", value: "expenses.edit" },
            { label: "Expenses Delete", value: "expenses.delete" }
        ]
    },
    {
        name: "Event",
        key: "event",
        permissions: [
            { label: "Event View", value: "event.view" },
            { label: "Event Create", value: "event.create" },
            { label: "Event Edit", value: "event.edit" },
            { label: "Event Delete", value: "event.delete" }
        ]
    },
    {
        name: "Commission",
        key: "commission",
        permissions: [
            { label: "Commission View", value: "commission.view" },
            { label: "Commission Create", value: "commission.create" },
            { label: "Commission Edit", value: "commission.edit" },
            { label: "Commission Delete", value: "commission.delete" }
        ]
    },
    {
        name: "Payment",
        key: "payment",
        permissions: [
            { label: "Payment View", value: "payment.view" },
            { label: "Payment Create", value: "payment.create" },
            { label: "Payment Edit", value: "payment.edit" },
            { label: "Payment Delete", value: "payment.delete" }
        ]
    },
    {
        name: "Refund",
        key: "refund",
        permissions: [
            { label: "Refund View", value: "refund.view" },
            { label: "Refund Create", value: "refund.create" },
            { label: "Refund Edit", value: "refund.edit" },
            { label: "Refund Delete", value: "refund.delete" }
        ]
    },
    {
        name: "Reports",
        key: "reports",
        permissions: [
            { label: "Report View", value: "report.view" },
            { label: "Report Create", value: "report.create" },
            { label: "Report Edit", value: "report.edit" },
            { label: "Report Delete", value: "report.delete" }
        ]
    },


    {
        name: "Settings",
        key: "settings",
        permissions: [
            { label: "Settings View", value: "settings.view" },
            { label: "Settings Edit", value: "settings.edit" }
        ]
    },
];
